import Swal from "sweetalert2";

const ssoAlert = {
    default: {
        showConfirmButton: false,
        footer: `<a href="#" id="btn_close_sso_alert" class="btn btn-primary text-white w-100 fw-semibold">${globalLanguage.ok}</a>`,
        showClass: {
            popup: ''
        },
        didRender: function () {
            $('#btn_close_sso_alert').on('click', function () {
                Swal.close();

                return false;
            });
        }
    },
    fire: function (config = null) {
        Swal.fire($.extend({}, this.default, config));
    },
    success: function (html, config = null) {
        Swal.fire(
            $.extend({}, this.default, {
                imageUrl: '/icon/modal/success.svg',
                imageWidth: 60,
                imageHeight: 60,
                title: globalLanguage.success,
                html: html,
                customClass: {
                    popup: 'sso-alert-success-popup',
                    image: 'sso-alert-status-image',
                    htmlContainer: 'sso-alert-status-html'
                }
            }, config)
        );
    },
    error: function (html) {
        Swal.fire($.extend({}, this.default, {
            imageUrl: '/icon/modal/fail.svg',
            imageWidth: 60,
            imageHeight: 60,
            title: globalLanguage.error,
            html: html,
            customClass: {
                popup: 'sso-alert-error-popup',
                image: 'sso-alert-status-image',
                htmlContainer: 'sso-alert-status-html'
            }
        }));
    },
    confirm: function (title, html, onConfirm, config = null) {
        const customClass = $.extend({
            popup: 'sso-alert-confirm-popup',
            image: 'sso-alert-status-image',
            htmlContainer: 'sso-alert-status-html'
        }, config?.customClass);

        Swal.fire($.extend({}, this.default, {
            imageUrl: '/icon/modal/warning.svg',
            imageWidth: 60,
            imageHeight: 60,
            title: title,
            html: html,
        }, config, {
            footer: `<div class="d-flex gap-3 w-100">
                <button type="button" id="btn_sso_alert_back" class="btn btn-outline-dark fw-semibold flex-fill">${globalLanguage.back}</button>
                <button type="button" id="btn_sso_alert_confirm" class="btn btn-dark fw-semibold flex-fill">${globalLanguage.ok}</button>
            </div>`,
            customClass: customClass,
            didRender: function () {
                $('#btn_sso_alert_back').on('click', function () {
                    Swal.close();
                    return false;
                });
                $('#btn_sso_alert_confirm').on('click', function () {
                    Swal.close();
                    if (typeof onConfirm === 'function') {
                        onConfirm();
                    }
                    return false;
                });
            }
        }));
    }
};

export default ssoAlert;
